import React, { useMemo } from 'react';
import Grid from '../../components/Grid';
import ActionIcon from '../../components/ActionIcon';
import Form from '../../components/Form';
import Searchers from '../utility/Searchers';
import Utils from '../utility/Utils';
import LoginService from '../services/LoginService';
import AppConstants from '../utility/AppConstants';

const CustDescTorqueReadingsTable = (props) => {
  const controller = props.controller;

  const totalReadingCount = controller.state.torqueReadings.reduce((acc, curr) => acc + curr.state.quantity, 0);

  const handleAddNewRow = () => {
    props.controller.addNewTorqueReadingRow();
  }

  const getRowProps = (row) => {
    const rowProps = {};
    if (row.original.ReadingType == AppConstants.ReadingType.Customer) {
      rowProps.className = 'cust-desc-background';
    }
    else {
      if (row.original.customerSelected) {
        rowProps.className = 'man-desc-background';
      }
      else {
        rowProps.className = 'man-desc-background unused-manufacturer-reading';
      }
    }
    return rowProps;
  }

  let divClassName = 'col-md-12';
  divClassName = controller.state.errors.torqueReadings ? ' has-error' : '';

  const data = [...controller.state.torqueReadings];

  const columns = useMemo(
    () => [
      {
        Header: '',
        accessor: 'action',
        Cell: (cellInfo) => {
          const controller = cellInfo.row.original;
          return controller.canRemoveRow()
            ? <ActionIcon icon='fa-trash' className='remove-handle' action={controller.removeRow} />
            : <span></span>;
        }
      },
      {
        Header: 'Use',
        accessor: 'state.customerSelected',
        Cell: (cellInfo, binder) => {
          const controller = cellInfo.row.original;
          const errors = controller.state.errors;
          return (cellInfo.row.original.state.readingType == AppConstants.ReadingType.Manufacturer)
            ? LoginService.isAdministrator ? <Form.CheckBox bind={binder.bind('customerSelected')} />
              : <span>{Utils.formatBool(cellInfo.value)}</span>
            : <span>{cellInfo.value}</span>;
        }
      },
      {
        Header: 'ID',
        accessor: 'state.readingId',
        Cell: (cellInfo, binder) => {
          const controller = cellInfo.row.original;
          const errors = controller.state.errors;
          return cellInfo.row.original.state.readingType == AppConstants.ReadingType.Customer && LoginService.isSuperUser
            ? <Form.Input bind={binder.bind('readingId')} className='required id-field' error={errors.readingId} placeholder='#' />
            : <span>{cellInfo.value}</span>
        }
      },
      {
        Header: 'Torque Location',
        accessor: 'state.torqueLocation',
        Cell: (cellInfo, binder) => {
          const controller = cellInfo.row.original;
          const errors = controller.state.errors;
          return cellInfo.row.original.state.readingType == AppConstants.ReadingType.Customer && LoginService.isSuperUser
            ? <Form.AutoComplete bind={binder.bind('torqueLocation')} className='required' error={errors.torquelocation} search={Searchers.searchTorqueLocation()} minimumResultsForSearch={-1} />
            : <span>{cellInfo.value.name}</span>
        }
      },
      {
        Header: 'Torque Range',
        accessor: 'state.torqueRange',
        Cell: (cellInfo) => <span>{cellInfo.value.name}</span>
      },
      {
        Header: 'Customer Torque Range',
        accessor: 'state.customerTorqueRange',
        Cell: (cellInfo, binder) => {
          const controller = cellInfo.row.original;
          const errors = controller.state.errors;
          return (cellInfo.row.original.state.readingType == AppConstants.ReadingType.Customer || (cellInfo.row.original.state.readingType == AppConstants.ReadingType.Manufacturer && cellInfo.row.original.state.customerSelected))
            ? LoginService.isSuperUser ? <Form.AutoComplete bind={binder.bind('customerTorqueRange')} className='required' error={errors.customerTorqueRange} search={Searchers.searchTorqueRange()} minimumResultsForSearch={-1} />
              : <span>{cellInfo.value.name}</span>
            : <span>{cellInfo.value.name}</span>;
        }
      },
      {
        Header: 'Type',
        accessor: 'state.readingType',
        Cell: (cellInfo) => <span>{cellInfo.value}</span>
      },
    ],
    []);

  return (
    <div className={divClassName}>
      <Grid id='torque-results-table' columns={columns} data={data} editable={true} canAddNewRow={false} getRowProps={getRowProps} onAddNewRow={handleAddNewRow} showPagination={false} noDataText='No torque readings exist yet' />
    </div>
  );
}

export default CustDescTorqueReadingsTable;